import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import { fetchTopic } from '../../../actions/topicclouds'
import { isExternalReviewer } from '../../../utils/user'

export default class Item extends PureComponent {
  constructor(props) {
    super(props)
    this.onClickBound = this.onClick.bind(this)
  }

  render() {
    const { topic, isSelected, user } = this.props

    return (
      <li>
        <div
          className={`topic ${isSelected ? 'selected' : ''}`}
          title={topic.name}
          data-topicid={topic.id}
          onClick={this.onClickBound}
        >
          <div className="name">{topic.name}</div>
          {!isExternalReviewer(user) && (
            <div className="count">
              <span>
                {topic.stats.descendants_quests_count
                  ? topic.stats.descendants_quests_count
                  : '0'}
              </span>
            </div>
          )}
        </div>
      </li>
    )
  }

  onClick(e) {
    this.props.dispatch(fetchTopic(e.currentTarget.dataset.topicid))

    const topics = document.querySelectorAll('#topicCloudTopics .topic')
    const arrTopics = [...topics] // spread operator allows us to forEach these DOM elements
    arrTopics.forEach(function (el) {
      el.classList.remove('selected')
    })

    e.currentTarget.classList.add('selected')
  }
}

Item.propTypes = {
  dispatch: PropTypes.func,
  topic: PropTypes.object,
  isSelected: PropTypes.bool,
  user: PropTypes.object
}



// WEBPACK FOOTER //
// ./src/components/topiccloud/topicmenu/Item.js